import $ from "jquery";

export default class StringUtil {
  public static isEmpty(str: string | undefined | null): boolean {
    return str === undefined || str === null || str === "";
  }

  public static isNotEmpty(str: string | undefined | null): boolean {
    return !this.isEmpty(str);
  }

  public static defaultString(str: string | undefined | null) {
    return str === undefined || str === null || str === "NULL" ? "" : str;
  }

  public static defaultIfEmpty(str: string | undefined | null, defaultStr: string) {
    return str === undefined || str === null || str === "" ? defaultStr : str;
  }

  public static replaceAll(str: string, sFindText: string, sReplaceText: string, bIgnoreCase?: boolean) {
    if (str == null || sFindText == null) {
      return str;
    }

    return String(str).replace(new RegExp(sFindText, "g" + (bIgnoreCase === true ? "i" : "")), sReplaceText);
  }

  public static leftPad(str: string, size: number, padString: string) {
    let padStr = "";

    while (str.length + padStr.length < size) {
      padStr += padString;
    }

    return padStr + str;
  }

  public static rightPad(str: string, size: number, padString: string, truncate?: boolean) {
    if (str == null) {
      return str;
    }

    str = String(str);

    if (truncate === true && str.length > size) {
      return str.substr(0, size);
    }

    while (str.length < size) {
      str = str + padString;
    }

    return str;
  }

  public static startsWith(str: string, sPrefix: string, bIgnoreCase?: boolean): boolean {
    if (str == null || sPrefix == null) {
      return false;
    }

    str = String(str);

    if (str.length < sPrefix.length) {
      return false;
    }

    if (bIgnoreCase === true) {
      return str.substr(0, sPrefix.length).toUpperCase() === sPrefix.toUpperCase();
    }

    return str.substr(0, sPrefix.length) === sPrefix;
  }

  public static endsWith(str: string, sSuffix: string, bIgnoreCase?: boolean): boolean {
    if (str == null || sSuffix == null) {
      return false;
    }

    str = String(str);

    if (str.length < sSuffix.length) {
      return false;
    }

    if (bIgnoreCase === true) {
      return str.substr(str.length - sSuffix.length).toUpperCase() === sSuffix.toUpperCase();
    }

    return str.substr(str.length - sSuffix.length) === sSuffix;
  }

  public static removeAllTag(str: string | undefined | null) {
    if (str == null) {
      return "";
    }

    return str.replace(/(<([^>]+)>)/gi, "").replace(/&nbsp;/gi, " ");
  }

  public static getTextFromHtml(html: string | undefined | null) {
    if (html == null) {
      return "";
    }

    html = StringUtil.replaceAll(html, "<br />", "\n", true);
    html = StringUtil.replaceAll(html, "<br/>", "\n", true);
    html = StringUtil.replaceAll(html, "<br>", "\n", true);

    if (this.getTextFromHtml.prototype.$pre == null) {
      this.getTextFromHtml.prototype.$pre = $(`<pre>`).hide().appendTo(`body`);
    }

    const text = this.getTextFromHtml.prototype.$pre.html(html).text();

    this.getTextFromHtml.prototype.$pre.empty();

    return text;
  }

  public static formatNumber(str: string | number, digits?: number, thousandsSeparator?: string) {
    if (str == null) {
      return str;
    }

    str = String(str);

    if (str === "") {
      return str;
    }

    if (thousandsSeparator == null) {
      thousandsSeparator = ",";
    }

    if (thousandsSeparator !== "") {
      str = this.replaceAll(str, thousandsSeparator, "");
    }

    if (digits != null) {
      str = String(Math.round(parseFloat(str) * Math.pow(10, digits)) / Math.pow(10, digits));
    }

    const minus = this.startsWith(str, "-");
    const txts = (minus === true ? str.substr(1) : str).split(".");

    const matches = this.defaultIfEmpty(txts[0], "0")
      .replace(new RegExp(thousandsSeparator, "g"), "")
      .split("")
      .reverse()
      .join("")
      .match(/.{1,3}/g);

    const fixed = matches == null ? "" : matches.join(thousandsSeparator).split("").reverse().join("");

    const decimal = this.rightPad(txts[1] == null ? "" : txts[1], digits == null ? 0 : digits, "0");

    return (minus === true ? "-" : "") + fixed + (decimal === "" ? "" : ".") + decimal;
  }

  public static telephoneFormat(num:string) {
    return num.replace(/[^0-9]/g, '')
        .replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,"$1-$2-$3");
  }

  /**
   * 사업자번호 및 법인번호 포맷
   *
   * @param num 사업자|법인 번호
   */
  public static bizCrpFormat(num: string | number ) {
    let formatNum = "";

    if (num == null) {
      return;
    }

    if (typeof num == "number") {
      num = num.toString();
    }

    num = StringUtil.replaceAll(num, "-", "");

    // 사업자번호
    if (num.length === 10) {
      formatNum = num.replace(/(\d{3})(\d{2})(\d{5})/, "$1-$2-$3");
    }

    // 법인번호
    if (num.length === 13) {
      formatNum = num.replace(/(\d{6})(\d{7})/, "$1-$2");
    }

    return formatNum;
  }

  /**
   * 협약 번호 포맷
   *
   * @param
   */
  public static arrgNoFormat(arrgNo: string | undefined) {
    let formatString = "";

    if (arrgNo == null) {
      return;
    }

    // 사업자번호
    formatString = arrgNo.replace(/(.{1})(\d{4})(\d{2})(\d{3})/g, "$1-$2-$3-$4");

    return formatString;
  }

  /**
   * 출연번호
   *
   * @param
   */
  public static donNoFormat(str: any) {
    if (StringUtil.isEmpty(str)) {
      return;
    }
    return str.replace(/(.{3})(.{4})(.{3})/g, "$1-$2-$3");
  }
  /**
   * 과제신청번호
   *
   * @param
   */
  public static tskReqNoFormat(str: any) {
    if (StringUtil.isEmpty(str)) {
      return;
    }
    return str.replace(/(.{1})(.{2})(.{5})/g, "$1-$2-$3");
  }

  /**
   * 지급번호
   *
   * @param
   */
  public static payNoFormat(str: any) {
    if (StringUtil.isEmpty(str)) {
      return;
    }
    return str.replace(/(.{3})(.{4})(.{3})/g, "$1-$2-$3");
  }

  /**
   * 환수번호
   *
   * @param
   */
  public static redeNoFormat(str: any) {
    if (StringUtil.isEmpty(str)) {
      return;
    }
    return str.replace(/(.{1})(.{2})(.{7})/g, "$1-$2-$3");
  }

  /**
   * 사업자등록번호 패턴 체크
   *
   * @param
   */
  public static checkCorporateRegiNumber(number: string) {
    const numberMap: number[] = number
      .replace(/-/gi, "")
      .split("")
      .map(function (d) {
        return parseInt(d, 10);
      });

    if (numberMap.length === 10) {
      const keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
      let chk = 0;

      keyArr.forEach(function (d, i) {
        chk += d * numberMap[i];
      });

      chk += parseInt((keyArr[8] * numberMap[8]) / 10 + "", 10);
      return Math.floor(numberMap[9]) === (10 - (chk % 10)) % 10;
    }

    return false;
  }

  /**
   * URL 패턴 검증
   *
   */
  public static patternURLAt(str: any) {
    if (StringUtil.isEmpty(str)) {
      return;
    }

    const reg = /(http(s)?:\/\/)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}/gi;

    return reg.test(str);
  }

  /**
   * 금액 한글화 출력
   *
   */
  public static numKorPattern(num: number) {
    // 1 ~ 9 한글 표시
    const arrNumberWord: string[] = ["", "일", "이", "삼", "사", "오", "육", "칠", "팔", "구"];
    // 10, 100, 100 자리수 한글 표시
    const arrDigitWord: string[] = ["", "십", "백", "천"];
    // 만단위 한글 표시
    const arrManWord: string[] = ["", "만", "억", "조"];

    const num_value = num + ""; //number to string
    const num_length = num_value.length;

    if (StringUtil.isEmpty(num_value)) {
      return;
    }

    if (num < 0) {
      return;
    }

    let han_value = "";
    let man_count = 0; // 만단위 0이 아닌 금액 카운트.

    for (let i = 0; i < num_value.length; i++) {
      // 1단위의 문자로 표시.. (0은 제외)
      let strTextWord = arrNumberWord[parseInt(num_value.charAt(i))];

      // 0이 아닌경우만, 십/백/천 표시
      if (strTextWord !== "") {
        man_count++;
        strTextWord += arrDigitWord[(num_length - (i + 1)) % 4];
      }

      // 만단위마다 표시 (0인경우에도 만단위는 표시한다)
      if (man_count !== 0 && (num_length - (i + 1)) % 4 === 0) {
        man_count = 0;
        strTextWord = strTextWord + arrManWord[(num_length - (i + 1)) / 4];
      }

      han_value += strTextWord;
    }

    return han_value;
  }

  public static upperSnakeToCamel(s:string) {
    return s.toLowerCase().replace(/(_\w)/g, m => m[1].toUpperCase());
  }

  /**
   * @param num 
   * @param type : 0 마스킹 처리 , 1 마스킹 안함 
   * @returns 
   */
  public static phoneFomatter(num:string,type:number){
    /*  사용 예제
    phoneFomatter('01000000000');   //010-0000-0000
    phoneFomatter('01000000000',0); //010-****-0000
    phoneFomatter('0100000000');    //010-000-0000
    phoneFomatter('0100000000',0);  //010-***-0000
    phoneFomatter('0200000000');    //02-0000-0000
    phoneFomatter('0200000000',0);  //02-****-0000
    phoneFomatter('0310000000');    //031-000-0000
    phoneFomatter('0310000000',0);  //031-***-0000
    phoneFomatter('16880000');      //1688-0000
    */
    let formatNum = "";
    if( num == null){
      return formatNum;
    }

    if (num.length == 11) {
      if (type == 0) {
      formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, "$1-****-$3");
      } else {
      formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      }
      
    } else if (num.length == 8) {
        formatNum = num.replace(/(\d{4})(\d{4})/, "$1-$2");
    } else {
      if (num.indexOf("02") == 0) {
        if (type == 0) {
        formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, "$1-****-$3");
        }
      if (num.length == 9) {
        formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, "$1-$2-$3");
      } else {
        formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
      }
      } else {
      if (type == 0) {
        formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, "$1-***-$3");
      } else {
          formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
      }
     }
   }

   return formatNum;
  }

  public static numberFormat(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  public static numberToKorean(number:number){
      var inputNumber:any  = number < 0 ? false : number;
      var unitWords    = ['', '만', '억', '조', '경'];
      var splitUnit    = 10000;
      var splitCount   = unitWords.length;
      var resultArray:any  = [];
      var resultString = '';

      for (var i = 0; i < splitCount; i++){
          var unitResult = (inputNumber % Math.pow(splitUnit, i + 1)) / Math.pow(splitUnit, i);
          unitResult = Math.floor(unitResult);
          if (unitResult > 0){
              resultArray[i] = unitResult;
          }
      }

      for (var i = 0; i < resultArray.length; i++){
          if(!resultArray[i]) continue;
          resultString = String(this.numberFormat(resultArray[i])) + unitWords[i] + resultString;
      }

      return resultString;
  }
}
